import { Division } from "components/common/division";
import { Paragraph } from "components/common/paragraph";

/**
 * Repräsentiert einen leeren Platzhalter.
 *
 * @remarks
 * Der Platzhalter ist vor allem beim Umgang mit Daten hilfreich. Können keine
 * Daten zurückgegeben werden, kann der Platzhalter zur Darstellung eines
 * diesbezüglichen Hinweises verwendet werden.
 *
 * @example
 * Das folgende Beispiel erstellt einen Platzhalter.
 *
 * Erstelle einen neuen Platzhalter.
 *
 * ```typescript
 * import { Empty } from "components/empty";
 *
 * const empty = new Empty("Keine Daten vorhanden.");
 * ```
 *
 * Rendere nun den Platzhalter in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(empty.render());
 * ```
 *
 * @public
 */
class Empty extends Division {
  /**
   * Das HTML Element für die Beschreibung.
   */
  private paragraph: Paragraph;

  /**
   * Erstellt einen neuen Platzhalter.
   *
   * @param description Eine Beschreibung.
   */
  constructor(description: string) {
    super();

    /* Erzeuge die erforderlichen HTML Elemente. */
    this.paragraph = new Paragraph();

    /* Füge die CSS Klassen hinzu. */
    this.withClass("empty");

    this.paragraph.withClass("paragraph");

    /* Füge die Beschreibung hinzu. */
    this.paragraph.withText(description);
  }

  /**
   * Gibt den Platzhalter zurück.
   *
   * @returns Den Platzhalter.
   * @override
   * @public
   */
  public render() {
    const { paragraph } = this;

    /* Erstelle das HTML Markup. */
    this.withChildren(paragraph);

    return this.element;
  }
}

export { Empty };
